export const NEW_AGE_RANGE = {
  min: 18,
  max: 54,
  value: '18 - 54',
  label: '18 - 54',
};
export const AGE_LIMITS = { MIN: 16, MAX: 85 };
export const AGE_LIMITS_HIDE_UNDER_EIGHTEEN = { MIN: 18, MAX: 85 };
export const AGE_RANGE_MIN_DIFFERENCE_CONSTRAINT = 1;
